import styled from "styled-components";
import { getValueFromPixelString } from "../../../utils/TokenHelpers";
import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
const QUICK_FIND_SEARCH_HEIGHT = 24;
const QUICK_FIND_PADDING = getValueFromPixelString(apolloSpaceInsetHalfX);
export const QUICK_FIND_HEIGHT = QUICK_FIND_SEARCH_HEIGHT + QUICK_FIND_PADDING * 2;
export const StyledQuickFind = styled.div.withConfig({ displayName: "StyledQuickFind_APC-7281-productShell", componentId: "sc-13dc30u" })(({ theme, $position }) => (Object.assign(Object.assign({ background: theme.colors.apolloColorBackgroundPopover, paddingInline: QUICK_FIND_PADDING }, ($position === "bottom" && {
    paddingBlock: `${QUICK_FIND_PADDING - 1}px ${QUICK_FIND_PADDING}px`,
    borderTop: `1px solid ${theme.colors.apolloColorStrokePopoverSeparator}`,
})), ($position === "top" && {
    paddingBlock: `${QUICK_FIND_PADDING}px ${QUICK_FIND_PADDING - 1}px`,
    borderBottom: `1px solid ${theme.colors.apolloColorStrokePopoverSeparator}`,
}))));
//# sourceMappingURL=QuickFind.style.js.map